<template>
    <div class="qiyeList">
        <v-header></v-header>
        <div class="mbx">
            <el-breadcrumb separator=">">
                <el-breadcrumb-item :to="{ path: '/' }" alt="小查线索">首页</el-breadcrumb-item>
                <el-breadcrumb-item><a :href="'/wordsList?text='+upLoadObj.keyword" alt="查推广">查推广</a></el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <query-list @queryType="queryFun"></query-list>
        <div class="danwei_list">
            <div class="danwei_list_title">
                搜索到企业数据：<span class="red">{{total}}</span>条
            </div>
            <img class="wuClass" v-if="showType == true" src="https://zyprogram.xinchacha.com/xiansuo/icon/index-wu.png" alt="" srcset="">
            <p class="wuClass_text" v-if="showType == true">暂无搜索结果</p>
            <p class="wuClass_text" v-if="showType == true">已经将您想搜索的关键词提交到小查线索</p>
            <p class="wuClass_text" v-if="showType == true">小查线索有结果后会以短信的形式通知您</p>
            <danwei-list-item :table-title="listObj" v-if="showType == false" ref="listItem"></danwei-list-item>
        </div>
        <div style="width:100%;height:20px"></div>
        <v-footer></v-footer>
    </div>
</template>
<script>
import vHeader from './common/header.vue';
import vFooter from './common/footer.vue'
import queryList from './modular/querylist.vue';
import danweiList from './modular/danweiList.vue'
import danweiListItem from './modular/danweiList.vue'
export default {
    data(){
        return{
            upLoadObj:{
				pageNum:1,
				keyword:'',
				down:[],
				stage:0,
				isPhone:'',
				isTel:'',
				isEmail:'',
				isUrl:'',
				industry:''
			},
            listObj:[],
            total:0,
            showType:false
        }
    },
    components:{
        vHeader,
        vFooter,
        queryList,
        danweiListItem
    },
    methods:{
        queryFun(data){
            var _this = this;
            if (data != undefined) {
                this.upLoadObj = {
                    pageNum:1,
                    keyword:data.keyword,
                    down:data.down,
                    stage:data.stage,
                    isPhone:data.isPhone,
                    isTel:data.isTel,
                    isEmail:data.isEmail,
                    isUrl:data.isUrl,
                    industry:data.industry
                }
            }
            this.postRequest('api/clue/getClue',this.upLoadObj).then(res=>{
                var data = res.data;
                if (data.status == 200) {
                    if (data.obj.content.length > 0) {
                        _this.showType = false;
                        var aa = [];
                        var item  = data.obj.content;
                        for (let index = 0; index < item.length; index++) {
                            aa.push(item[index]);
                        }
                        if (_this.listObj.length == 0) {
                            _this.listObj = aa
                            _this.total = data.obj.totalElements;
                            _this.$refs.listItem.changeTableObj(aa);
                        } else {
                            _this.$refs.listItem.changeTableObj(aa);
                            _this.listObj = aa
                            _this.total = data.obj.totalElements;
                        }
                    } else {
                        _this.total = 0;
                        _this.listObj = [];
                        _this.showType = true;
                    }
                    
                };
            })
        },
        fanyeFun(){
            var _this = this;
            this.upLoadObj.pageNum = _this.upLoadObj.pageNum+1;
            this.postRequest('api/clue/getClue',this.upLoadObj).then(res=>{
                var data = res.data;
                if (data.status == 200) {
                    _this.$refs.listItem.addTableObj(data.obj.content);
                }
            })
        }
    },
    created(){
        var _this = this;
        window.onscroll = function(){
            //变量scrollTop是滚动条滚动时，距离顶部的距离
            var scrollTop = document.documentElement.scrollTop||document.body.scrollTop;
            //变量windowHeight是可视区的高度
            var windowHeight = document.documentElement.clientHeight || document.body.clientHeight;
            //变量scrollHeight是滚动条的总高度
            var scrollHeight = document.documentElement.scrollHeight||document.body.scrollHeight;
            //滚动条到底部的条件
            if(scrollTop+windowHeight==scrollHeight){
                _this.fanyeFun();
            }   
        }
    },
    mounted(){
        this.upLoadObj.keyword = this.$route.query.text;
        this.queryFun();
    }
}
</script>
<style lang="scss" scoped>
.qiyeList{
    width: 100%;
    height: auto;
    background-color: #F8F8F8;
}

.mbx{
    height: 40px;
    line-height: 40px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    cursor: default;
    @media screen and (max-width: 1400px){
        width: 960px;
    }
    @media screen and (min-width: 1400px){
        width: 1200px;
    }
    a{
        cursor: default !important;
    }
}

.danwei_list{
    height: auto;
    padding-bottom: 20px;
    margin-bottom: 20px;
    @media screen and (max-width: 1400px){
        width: 960px;
        margin: 20px auto 0;
        background-color: #fff;
    }
    @media screen and (min-width: 1400px){
        width: 1200px;
        margin: 20px auto 0;
        background-color: #fff;
    }
    >div.danwei_list_title{
        width: 100%;
        height: 68px;
        line-height: 68px;
        padding-left: 34px;
        box-sizing: border-box;
        font-size: 22px;
        font-weight: 500;
        border-bottom: 2px solid #F6F7FB;
        cursor: default;
        >span.red{
            color: #FF0000;
        }
    }
    >div.danwei_list_dom{
        width: 100%;
        height: auto;
        padding: 30px;
        box-sizing: border-box;
        // >div
    }
    >img.wuClass{
        width: 40%;
        height: auto;
        display: block;
        margin: 60px auto 30px;
    }
    >p.wuClass_text{
        width: 100%;
        height: auto;
        text-align: center;
        font-size: 16px;
        color: #666;
        margin-top: 10px;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/qiyelist.vue